module.exports = __webpack_public_path__ + "static/media/logo.589b3ef6.png";